@for (column of columns; track column) {
  <ds-table-header-cell [ngClass]="{ 'none md-flex': column.hideOnMobile }" [column]="column">
  </ds-table-header-cell>
}
